import { StudioResourceTypeEnum } from '@pypestream/api-services';

import { AGENT_TEMPLATES } from '../../../utils/agent-templates';
import {
  specRowCount,
  specToRows,
} from '../../../stores/utils/agent-spec-rows';
import type { ResourceLibItem } from '../../../xstate/prostudio.xstate.types';

import { AGENT_TEMPLATE_ITEM_PREFIX } from './category-map';

/**
 * Project Bobcat (agent templates) — the agent templates as Resource
 * Library microagents, in their own "Agent templates" category: each is the
 * template's steps as rows. The numbers are provisional (1, 2, 3…); inserting
 * renumbers them past the solution's highest and rewrites the references
 * among them (`prepareResourceLibRows`), buttons included. A finished task
 * waits for the customer's next question, which the solution's Supervisor
 * routes; the template's scripts upload with it (`uploadResourceLibScripts`).
 */
export const agentTemplateItems = (): ResourceLibItem[] =>
  AGENT_TEMPLATES.map((template) => {
    const count = specRowCount(template.spec);
    return {
      id: `${AGENT_TEMPLATE_ITEM_PREFIX}${template.id}`,
      type: StudioResourceTypeEnum.MicroAgent,
      name: template.name,
      nodes: count,
      description:
        `${template.description} ${template.spec.connect.join(' ')}`.trim(),
      data: specToRows(template.spec, {
        numbers: Array.from({ length: count }, (_, i) => i + 1),
        returnTo: null,
      }),
    };
  });
